<template>
  <v-select class="model-select"
            :dense="dense"
            :menu-props="menuProps"
            item-text="label"
            :items="options"
            :label="label"
            :hint="hint"
            :placeholder="placeholder"
            :persistent-hint="!!hint"
            v-model="localInput"
            @input="setInput"
            :readonly="readonly"
            :disabled="disabled"
            :success="success"
            :error="forceError"
            :error-messages="errorMessages"
            :data-vv-name="fullPath"
            :data-vv-as="alias"
            :append-icon="appendIcon"
            :return-object="returnObject"
            :hide-details="hideDetails && !errorMessages.length"
            v-validate="validatorRule"
            :outlined="outlined"
            :multiple="multiple"
            :no-data-text="$t('field.options.empty')">
    <template #item="{ item }">
      <div data-test="option"
           class="d-flex flex-row align-center"
           :style="{ color: color(item) }">
        <v-img v-if="item.image"
               data-test="option-image"
               :src="item.image"/>

        <span class="pl-2">{{item.label}}</span>
      </div>
    </template>

    <template #selection="{ item }">
      <div data-test="selected-value"
           class="d-flex flex-row align-center"
           :style="{ color: color(item) }">
        <v-img data-test="image"
               max-width="30"
               v-if="item.image"
               :src="item.image"/>

        <span class="pl-2">{{item.label}}</span>
      </div>
    </template>
  </v-select>
</template>

<script lang="ts">
import FieldMixin from '@/components/Mixins/FieldMixin.vue';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { SelectOption } from '@/classes/SelectOption';

@Component
export default class SelectField extends Mixins(FieldMixin) {
  @Prop({ type: String })
  public readonly appendIcon: string | undefined;

  @Prop({ type: Array, required: true })
  public readonly options!: SelectOption[];

  @Prop({ type: String })
  public readonly validatorRule: string | undefined;

  @Prop({ type: Boolean })
  public readonly returnObject: boolean | undefined;

  @Prop({ type: String })
  public readonly hint: string | undefined;

  @Prop({ type: String })
  public readonly placeholder: string | undefined;

  @Prop({ type: Boolean })
  public readonly multiple: boolean | undefined;

  public readonly menuProps = { auto: true };

  public color(option: SelectOption) {
    return option.color ?? 'black';
  }

  private setInput(value: any | undefined) {
    this.localInput = value;
    this.$emit('setInput', this.localInput);
  }
}
</script>
